<div class="mac-address-form-container" *transloco="let t; prefix: 'mac-address-form'">
    <!-- Loading overlay -->
    <owc-backdrop *ngIf="isLoading" class="loading-overlay" disableScrollLock>
        <owc-progress-spinner size="large"></owc-progress-spinner>
    </owc-backdrop>

    <div class="mac-address-form-card">
        <owc-card dragging elevated rounded class="card">
            <owc-component-header slot="header">
                <h2> {{ t('title') || 'cobas® liat analyzer MAC Address Finder' }}</h2>
            </owc-component-header>
            <div class="mac-address-content">
                <form [formGroup]='macAddressForm' (ngSubmit)='sendMacAddressRequest()'>
                    <owc-input formControlName='macAddresses' ngDefaultControl auto-focus controlled resizable rounded type="textarea"
                        [name]="'Serial No.'" [rows]="rows" [placeholder]="t('placeholder')" [cols]="cols"
                        (valueChange)="onInputChange($event)">
                    </owc-input>


                    <owc-assistive-text class="assistive-text" trigger="input, blur">
                        {{ t('note') }}
                    </owc-assistive-text>
                    <owc-assistive-text class="assistive-text validation-error" trigger="input, blur"
                        *ngIf="macAddressForm.controls['macAddresses'].hasError('maxSerialnumberNumbers')">
                        {{ t('tooManySerialNumbers') }}
                    </owc-assistive-text>
                    <div class="action-buttons">
                        <owc-button class="button" elevated size="medium" type="reset" variant="secondary">
                            {{ t('clear') }}
                        </owc-button>
                        <owc-button class="button" [disabled]="macAddressForm.invalid || isLoading" elevated size="medium"
                            type="submit" variant="primary">
                            {{ t('submit') }}
                        </owc-button>
                    </div>
                </form>
            </div>
        </owc-card>
    </div>
</div>